<template>
    <div class="login__header">
        <div class="login__header-logo-box">
            <img class="login__header-logo" :src="`${$store.state.config.setup.logo}`" />
        </div>
    </div>
</template>
<script>
export default {};
</script>
